import React from "react";
import { Box } from "@mui/material";
import { useAppSelector } from "redux/hooks";
import { RootState } from "utils/store";
import EmailPreviewComponent from "../../components/EmailPreviewComponent";

/**
 * Step 6 — email preview shown before the final send. Renders the exact same
 * EmailPreviewComponent the desktop flow uses, so the details (From/To/CC/
 * Subject + templated body + branding footer) match the desktop 1:1. The
 * Figma "Placing for" bar is intentionally omitted.
 */
const MobilePreview: React.FC = () => {
  const signRequest = useAppSelector(
    (state: RootState) => state.app.signRequest,
  );

  return (
    <Box sx={{ px: 2, pt: 2, pb: 2 }}>
      <EmailPreviewComponent signRequest={signRequest} isMobile />
    </Box>
  );
};

export default MobilePreview;
